/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from 'react'
import FeatureDialog, { Props as DialogProps } from './DialogWindow/FeatureDialog'
import styled from 'styled-components'
import theme, { PrimaryColors } from '../../utils/theme'
import useMedia from 'lib/hooks/useMedia'
import { deviceSize } from 'lib/constants/GridBreakpoints'

const DialogWrapper = styled.div<{ sectionColor: PrimaryColors }>`
    width: 100%;
    height: auto;
    display: grid;
    position: relative;

    grid-template-rows: auto 1fr;
    .top {
        width: 400px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: ${({ sectionColor }) => sectionColor};
        margin: 0 -20px;
        padding: 5px 0;
        gap: 35px;
        height: 180px;
        overflow: hidden;
        img {
            z-index: 20;
            object-fit: scale-down;
        }
    }

    .bottom {
        width: 360px;
        padding: 20px 10px 0 10px;
        display: grid;
        place-content: start;
        gap: 40px;
        height: auto;
    }
    @media (max-width: 750px) {
        width: 100%;
        .top {
            width: 350px;
        }
        .bottom {
            width: 100%;
            max-width: 350px;
        }
    }
`

interface Props extends DialogProps {
    sectionColor: PrimaryColors
    image: ReactNode
}

const InformationDialog = ({ open, onClose, ariaPrefix, sectionColor, image, children, maxWidth }: Props) => {
    const md = useMedia(deviceSize.md)

    return (
        <FeatureDialog
            open={open}
            onClose={onClose}
            title=""
            ariaPrefix={ariaPrefix}
            backgroundColor={theme.colors.white}
            hideTitle
            maxWidth={md ? 350 : 400}
            hideCloseButton
            allowVerticalOverflow
        >
            <DialogWrapper sectionColor={sectionColor}>
                <div className="top">{image}</div>
                <div className="bottom">{children}</div>
            </DialogWrapper>
        </FeatureDialog>
    )
}

export default InformationDialog
